"use client";
import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  Typography,
} from "@material-tailwind/react";
import {
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import { create } from "zustand";

export enum DialogMode {
  SUCCESS,
  WARNING,
  INFO,
}
export type TNotificationDialog = {
  mode: DialogMode;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  enabledPressBackdrop?: boolean;
  closeBtnTitle?: string;
  onCloseBtn?: () => void;
  confirmBtnTitle?: string;
  onConfirmBtn?: () => void;
  onPressBackdrop?: () => void;
};

type TDialogStates = {
  isOpen: boolean;
};
const defaultDialogStates: TDialogStates = { isOpen: false };
export const dialogStates = create<TDialogStates>(() => defaultDialogStates);

export function NotificationDialog({
  mode,
  isOpen,
  onClose,
  title,
  description = "",
  enabledPressBackdrop = true,
  closeBtnTitle,
  onCloseBtn = () => {},
  confirmBtnTitle,
  onConfirmBtn = () => {},
}: TNotificationDialog) {
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleOpen = () => {
    if (!enabledPressBackdrop) return;
    if (isOpen) onClose();
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} className="font-noto">
        {/* <DialogHeader>
          <Typography variant="h5" color="blue-gray">
            Your Attention is Required!
          </Typography>
        </DialogHeader> */}
        <DialogBody divider className="grid place-items-center gap-4">
          {mode === DialogMode.SUCCESS && (
            <CheckCircleIcon width={80} height={80} color="#188F46" />
          )}
          {mode === DialogMode.WARNING && (
            <InformationCircleIcon width={80} height={80} color="red" />
          )}
          {mode === DialogMode.INFO && (
            <InformationCircleIcon width={80} height={80} color="#188F46" />
          )}
          <Typography
            className={
              mode === DialogMode.SUCCESS
                ? "text-[#188F46] font-noto"
                : "font-noto"
            }
            variant="h4"
          >
            {title}
          </Typography>
          <Typography className="text-center font-normal max-w-[500px] font-noto">
            {description}
          </Typography>
        </DialogBody>
        {(closeBtnTitle || confirmBtnTitle) && (
          <DialogFooter className="space-x-2">
            {closeBtnTitle && (
              <Button
                variant="text"
                color="blue-gray"
                onClick={onCloseBtn}
                className="font-noto"
                name="notification-close"
                aria-label={`ปิดการแจ้งเตือน - ${closeBtnTitle}`}
              >
                {closeBtnTitle}
              </Button>
            )}
            {confirmBtnTitle && (
              <Button
                variant="gradient"
                onClick={onConfirmBtn}
                className="font-noto"
                name="notification-confirm"
                aria-label={`ยืนยันการแจ้งเตือน - ${confirmBtnTitle}`}
              >
                {confirmBtnTitle}
              </Button>
            )}
          </DialogFooter>
        )}
      </Dialog>
    </>
  );
}
